import { createFileRoute } from '@tanstack/react-router'
import { EntityTypeList } from '@/components/events'

export const Route = createFileRoute('/events/entity-types/')({
  staticData: {
    title: 'Entity Types',
    isSecured: true,
  },
  component: EntityTypeList,
})
